import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';

const Services = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-purple-900 py-20">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
      <div className="text-center mb-14">
        <p className="text-blue-600 dark:text-blue-400 font-semibold mb-4">FREELANCE QA CONSULTING</p>
        <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6">What I Offer Clients</h1>
        <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">From the first test plan to the release decision, I help you understand product risks and deliver reliable software with clear, actionable evidence.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {services.map((service) => (
          <article key={service.title} className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg border border-gray-200 dark:border-gray-700">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{service.title}</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">{service.description}</p>
            <p className="text-sm font-semibold text-blue-600 dark:text-blue-400 mb-2">What you receive</p>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{service.deliverable}</p>
          </article>
        ))}
      </div>
      <section className="mt-16 p-8 md:p-12 rounded-3xl bg-blue-100 dark:bg-blue-900/30">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">How We Work Together</h2>
        <ol className="grid md:grid-cols-3 gap-8 text-gray-700 dark:text-gray-300 list-decimal list-inside">
          <li><strong>Understand the product.</strong><p className="mt-2">Review your goals, critical journeys, release timeline and available environments.</p></li>
          <li><strong>Agree on coverage.</strong><p className="mt-2">Prioritize risk and define the scope, deliverables and reporting approach.</p></li>
          <li><strong>Test and communicate.</strong><p className="mt-2">Share evidence, validate fixes and summarize remaining risks for your release decision.</p></li>
        </ol>
        <div className="flex flex-wrap gap-4 mt-10">
          <Link to="/contact" className="px-6 py-3 rounded-full bg-blue-600 hover:bg-blue-700 text-white font-medium">Discuss Your Project</Link>
          <Link to="/projects" className="px-6 py-3 rounded-full bg-white dark:bg-gray-800 text-blue-700 dark:text-blue-300 font-medium">View Freelance Projects</Link>
        </div>
      </section>
    </div>
  </div>
);

export default Services;
